// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const CheckDiscIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm4.71 8.71l-5 5A1 1 0 0111 16a1 1 0 01-.71-.29l-3-3a1 1 0 011.42-1.41L11 13.59l4.29-4.3a1 1 0 011.42 1.42z" fill="currentColor"/></svg>'} />;

CheckDiscIcon.displayName = 'CheckDiscIcon';

export default CheckDiscIcon;
